module.exports = __webpack_public_path__ + "assets/zuche.375dcb4a.svg";